import {
  queryGoodsList,
  queryMyGroupList,
  queryGroupDetail,
  queryInHandGroupList,
  getMyInHandGroupList,
  getVerifyGroupStatus,
  getVerifySponsorGroup,
  getVerifyJoinGroup
} from "@/api/group/goods";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    async queryGoodsList(context, params) {
      const data = await queryGoodsList(params);
      return data;
    },

    async queryMyGroupList(context, params) {
      const data = await queryMyGroupList(params);
      return data;
    },

    async queryGroupDetail(context, params) {
      const data = await queryGroupDetail(params);
      return data;
    },

    async queryInHandGroupList(context, params) {
      const data = await queryInHandGroupList(params);
      return data;
    },

    async getMyInHandGroupList(context, params) {
      const data = await getMyInHandGroupList(params);
      return data;
    },

    async getVerifyGroupStatus(context, params) {
      const data = await getVerifyGroupStatus(params);
      return data;
    },

    async getVerifySponsorGroup(context, params) {
      const data = await getVerifySponsorGroup(params);
      return data;
    },

    async getVerifyJoinGroup(context, params) {
      const data = await getVerifyJoinGroup(params);
      return data;
    }

  }
};
